var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
var Heading = React.forwardRef(function (_a, ref) {
    var _b, _c, _d, _e, _f;
    var children = _a.children, className = _a.className, error = _a.error, inline = _a.inline, noMargin = _a.noMargin, withBorder = _a.withBorder, lookLike = _a.lookLike, textCenter = _a.textCenter, level = _a.level, rest = __rest(_a, ["children", "className", "error", "inline", "noMargin", "withBorder", "lookLike", "textCenter", "level"]);
    var headingClass = "ffe-h".concat(lookLike ? lookLike : level);
    return React.createElement("h".concat(level), __assign(__assign({}, rest), { ref: ref, className: classNames(headingClass, (_b = {}, _b["".concat(headingClass, "--error")] = error, _b), (_c = {}, _c["".concat(headingClass, "--inline")] = inline, _c), (_d = {}, _d["".concat(headingClass, "--no-margin")] = noMargin, _d), (_e = {}, _e["".concat(headingClass, "--with-border")] = withBorder, _e), (_f = {}, _f["".concat(headingClass, "--text-center")] = textCenter, _f), className) }), children);
});
export var Heading1 = React.forwardRef(function (props, ref) { return React.createElement(Heading, __assign({}, props, { ref: ref, level: 1 })); });
export var Heading2 = React.forwardRef(function (props, ref) { return React.createElement(Heading, __assign({}, props, { ref: ref, level: 2 })); });
export var Heading3 = React.forwardRef(function (props, ref) { return React.createElement(Heading, __assign({}, props, { ref: ref, level: 3 })); });
export var Heading4 = React.forwardRef(function (props, ref) { return React.createElement(Heading, __assign({}, props, { ref: ref, level: 4 })); });
export var Heading5 = React.forwardRef(function (props, ref) { return React.createElement(Heading, __assign({}, props, { ref: ref, level: 5 })); });
export var Heading6 = React.forwardRef(function (props, ref) { return React.createElement(Heading, __assign({}, props, { ref: ref, level: 6 })); });
